const Edit = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.693 6.307a1.55 1.55 0 0 0-2.19 0l-8.859 8.859c-.227.227-.29.293-.337.364a1 1 0 0 0-.11.23c-.026.08-.039.17-.074.49l-.203 1.83 1.83-.203c.319-.035.41-.048.49-.074a1 1 0 0 0 .23-.11c.07-.047.137-.11.364-.337l8.859-8.859a1.55 1.55 0 0 0 0-2.19M14.796 5.6A2.549 2.549 0 1 1 18.4 9.204L9.54 18.063l-.029.03c-.184.184-.325.325-.491.434a2 2 0 0 1-.473.228c-.19.06-.387.083-.646.111l-.042.005-2.451.272a.5.5 0 0 1-.552-.552l.272-2.451.005-.042c.028-.259.05-.457.111-.646m9.55-9.852L5.938 14.46zM5.938 14.46l-.03.03zm-.03.03c-.184.184-.325.324-.434.49zm-.434.49a2 2 0 0 0-.228.473z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m5.245 15.452 9.55-9.852-8.858 8.859-.03.03-.434.49z"
    />
  </>
)
export default Edit
